﻿import LfDataService from '../../../Services/LfDataService';
import LfWebService from '../../../Services/LfWebService';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

export function loadProfilePageDataAction() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        lfDataService.memberInfo()
            .then(data => {
                dispatch(profilePageLoadedAction({
                    memberInfo: data.memberInfo,
                    coinsuredInfo: data.currentCoInsured
                }));

                dispatch(pageIsLoadingAction(false));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export function profilePageLoadedAction(data) {
    return {
        type: 'PROFILE_PAGE_LOADED',
        data
    };
}

export function submitProfileFormAction(data) {
    const lfDataService = new LfDataService();
    const lfWebService = new LfWebService(); 

    return (dispatch) => {
        dispatch(pageIsLoadingAction(true));

        lfDataService.updateProfile(data)
            .then(result => {
                if (result.success) {
                    lfWebService.myPages();
                    return;
                }

                dispatch(pageIsLoadingAction(false));
                dispatch(pageErrorAction('kunde inte uppdatera dina uppgifter'));
                dispatch(pageHasErroredAction(true));
            })
            .catch(e => {
                dispatch(pageIsLoadingAction(true));
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}